import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-analyst-renderer",
  template: `
    <span *ngIf="tooltipVal == ''">
      {{ displayName }}
    </span>
    <span
      class="show-tooltip"
      *ngIf="tooltipVal != ''"
      nz-tooltip
      nzTooltipTitle="Additional analysts: {{ tooltipVal }}"
    >
      {{ displayName }}
    </span>
  `,
  styles: [".show-tooltip{cursor:pointer; }"],
})
export class AnalystRendererComponent implements OnInit {
  @Input() analysts: Array<any>;
  displayName: string;
  tooltipVal: string;

  ngOnInit() {
    if (this.analysts.length > 1) {
      this.displayName = this.analysts.map((value) => {
        return value.isPrimary ? value.displayName : undefined;
      })[0];

      this.tooltipVal = this.analysts
        .map((val) => {
          return val.displayName !== this.displayName
            ? val.displayName
            : undefined;
        })
        .filter((v) => v !== void 0)
        .join(", ");
    } else if (this.analysts.length === 1) {
      this.displayName = this.analysts[0].displayName;
      this.tooltipVal = "";
    }
  }
}
